import {brand, Branded, number} from 'io-ts';

export const CardId = brand(number, (n): n is CardId => true, 'CardId');

export type CardId = Branded<
    number,
    {
        readonly CardId: unique symbol;
    }
>;
